/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('plugins/chatmapper-tree/chatmapper-tree',['require','jquery','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  //var templates = require('core/templates');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var ChatmapperTree = Marionette.Object.extend({

    /////////////////
    // PROPERTIES //{
    /////////////////

    element: null,

    /*****************************************************************************************************************///}

    //////////////////
    // CONSTRUCTOR //{
    //////////////////

    initialize: function()
    {
      this.templates = { };

      this.initializeVars();
    },

    initializeVars: function()
    {
      this.childWindow = null;

      // Calculate total nodes, max label length
      this.totalNodes = 0;
      this.maxLabelLength = 0;
      // variables for drag/drop
      this.selectedNode = null;
      this.draggingNode = null;
      // panning variables
      this.panSpeed = 200;
      this.panBoundary = 20; // Within 20px from edges will pan when dragging.
      // Misc. variables
      this.totalNodeIndex = 0;
      this.duration = 750;
      this.root = null;

      // size of the diagram
      this.viewerWidth = null;
      this.viewerHeight = null;

      this.tree = null;
      this.lastUpdateNode = null;

      // define a this.d3 diagonal projection for use by the node paths later on.
      this.diagonal = null;

      this.treeDOM = null;

      // define the baseSvg, attaching a class for styling and the zoomListener
      this.baseSvg = null;

      // Append a group which holds all nodes and which the zoom Listener can act upon.
      this.svgGroup = null;
    },

    checkWin: function(__callback)
    {
      var __winOpen = (this._cWindow && !this._cWindow.closed);

      if (!__winOpen && __callback !== undefined)
      {
        this._cWindow = window.open('plugins/chatmapper-tree/chatmapper-tree.html', 'chats', 'resizable=no, width=700px, height=500px');
        window.onunload = $.proxy(this.closeTreeWin, this);

        if (this._cWindow.document && this._cWindow.document.title === 'Chatmapper Tree')
        {
          __winOpen = true;
          this._cWindow.onunload = $.proxy(function() {this._cWindow = null; this.d3 = null; this.ready = null;}, this);
        }
        else
        {
          this._cWindow.onload = $.proxy(function() {
            this._cWindow.onunload = $.proxy(function() {this._cWindow = null; this.d3 = null; this.ready = null;}, this);
            __callback();
          }, this);
        }
      }

      return __winOpen;
    },

    closeTreeWin: function()
    {
      if (this._cWindow && !this._cWindow.closed)
        this._cWindow.close();
    },

    newTree: function(__dataObj)
    {
      //alert('new tree')
      this.lastUpdateNode = null;
      if (!this.checkWin($.proxy(this.newTree, this, __dataObj)))
        return;

      this.initializeVars();

      this.buildTree(__dataObj);
    },

    buildTree: function(__treeData)
    {
      if (!this.checkWin($.proxy(this.buildTree, this, __treeData)))
        return;

      this.treeDOM = this._cWindow.document;
      $(this.treeDOM).find('#tree-container').empty();

      this.d3 = this._cWindow.d3;
      //console.log(this);
      //console.log(this._cWindow);
      //console.log(this.d3);

      this.zoomListener = this.d3.behavior.zoom().scaleExtent([0.1, 3]).on('zoom', $.proxy(this.zoom, this));

      // size of the diagram
      this.viewerWidth = $(this.treeDOM).width();
      this.viewerHeight = $(this.treeDOM).height();

      this.tree = this.d3.layout.tree()
        .size([this.viewerWidth, this.viewerHeight]);//T/B

      // define a this.d3 diagonal projection for use by the node paths later on.
      this.diagonal = this.d3.svg.diagonal()
        .projection(function(d) {
          return [d.x, d.y];//T/B
        });

      this.visit(__treeData, $.proxy(function(d) {
        this.totalNodes++;
        this.maxLabelLength = Math.max(d.name.length, this.maxLabelLength);
      }, this), function(d) {
        return d.children && d.children.length > 0 ? d.children : null;
      });

      this.sortTree();

      // define the baseSvg, attaching a class for styling and the zoomListener
      this.baseSvg = this.d3.select('#tree-container').append('svg')
        .attr('width', this.viewerWidth)
        .attr('height', this.viewerHeight)
        .attr('class', 'overlay')
        .call(this.zoomListener);

      //console.log('BASE SVG');
      //console.log(this.baseSvg);

      // Append a group which holds all nodes and which the zoom Listener can act upon.
      this.svgGroup = this.baseSvg.append('g');

      // Define the root
      this.root = __treeData;
      //this.root.x0 = this.viewerHeight / 2;//L/R
      this.root.y0 = this.viewerHeight / 2;//T/B
       //this.root.y0 = 0;//L/R
      this.root.x0 = 0;//T/B

      var __node = this.lastUpdateNode || this.root;
      if (typeof __node === 'string')
      {
        this.updateByID(__node);
        return;
      }

      // Layout the tree initially and center on the root node.
      this.updateTree(__node);
      this.centerNode(__node);

      // A recursive helper for: function performing some setup by walking through all nodes
    },

    // Call visit to: function establish maxLabelLength
    visit: function(__parent, __visitFn, __childrenFn)
    {
      if (!__parent)
        return;

      __visitFn(__parent);

      var __children = __childrenFn(__parent);
      if (__children) {
        var __count = __children.length;
        for (var i = 0; i < __count; i++) {
          this.visit(__children[i], __visitFn, __childrenFn);
        }
      }
    },

    // sort the tree according to the node names
    sortTree: function()
    {
      this.tree.sort(function(__a, __b) {
        return __b.name.toLowerCase() < __a.name.toLowerCase() ? 1 : -1;
      });
    },

    zoom: function()
    {
      this.svgGroup.attr('transform', 'translate(' + this.d3.event.translate + ')scale(' + this.d3.event.scale + ')');
    },

    // Helper functions for collapsing and expanding nodes.
    updateByID: function(__id, __centerOnly)
    {
      __centerOnly = (__centerOnly === undefined) ? false : __centerOnly;
      this.lastUpdateNode = __id;

      if (!this.svgGroup)
        return;

      var __nodes = this.svgGroup.selectAll('g.' + __id).data();
      var __dataNode;

      for (var __key in __nodes)
      {
        __dataNode = __nodes[__key];

        if (!__dataNode.symLink)
          break;
      }

      if (__dataNode)
      {
        this.lastUpdateNode = __dataNode;

        if (!this.checkWin())
          return;

        if (!__centerOnly)
          this.updateTree(__dataNode);

        this.centerNode(__dataNode);
      }
    },

    collapse: function(__d)
    {
      if (__d.children)
      {
        __d._children = __d.children;
        __d._children.forEach($.proxy(this.collapse, this));
        __d.children = null;
      }
    },

    expand: function(d)
    {
      if (d._children) {
        d.children = d._children;
        d.children.forEach($.proxy(this.expand, this));
        d._children = null;
      }
    },

    overCircle: function(d)
    {
      this.selectedNode = d;
      //this.updateTempConnector();
      this.updateNodeInfo(d);
    },

    outCircle: function(d)
    {
      this.selectedNode = null;
      this.updateNodeInfo(this.lastUpdateNode);
      //this.updateTempConnector();
    },

    updateNodeInfo: function(__node)
    {
      console.warn('update node info', __node);
      if (!__node)
        return;

      var __info = $(this._cWindow.document).find('#node-info');
      //console.log(__node);

      __info.empty();

      __info.append($('<div>').attr('id', 'nl-id').addClass('node-label').html('ID: ').append($('<span>').addClass('node-data').html(__node.nlID)));
      __info.append($('<div>').attr('id', 'name').addClass('node-label').html('Name: ').append($('<span>').addClass('node-data').html(__node.name)));
      __info.append($('<div>').attr('id', 'description').addClass('node-label').html('Description: ').append($('<span>').addClass('node-data').html(__node.description)));
      __info.append($('<div>').attr('id', 'dialog-text').addClass('node-label').html('DialogText: ').append($('<span>').addClass('node-data').html(__node.dialogText)));
      __info.append($('<div>').attr('id', 'node-type').addClass('node-label').html('Type: ').append($('<span>').addClass('node-data').html(__node.dType)));

      __info.append($('<div>').attr('id', 'node-script').addClass('node-label').html('Scripts: ').append($('<span>').addClass('node-data').html(__node.script)));
      __info.append($('<div>').attr('id', 'node-conditions').addClass('node-label').html('Conditions: ').append($('<span>').addClass('node-data').html(__node.conditions)));

      __info.append($('<div>').attr('id', 'node-question').addClass('node-label').html('isQuestion: ').append($('<span>').addClass('node-data').html(__node.isQuestion)));
      __info.append($('<div>').attr('id', 'node-feedback').addClass('node-label').html('isFeedback: ').append($('<span>').addClass('node-data').html(__node.isFeedback)));
      __info.append($('<div>').attr('id', 'sym-link').addClass('node-label').html('isSymLink: ').append($('<span>').addClass('node-data').html(__node.symLink)));
      __info.append($('<div>').attr('id', 'is-group').addClass('node-label').html('isGroup: ').append($('<span>').addClass('node-data').html(__node.isGroup)));
      __info.append($('<div>').attr('id', 'node-color').addClass('node-label').html('nodeColor: ').append($('<span>').addClass('node-data').html(__node.color)));

      // __info.find('#nl-id .node-data').html(__node.nlID);
      // __info.find('#sym-link .node-data').html(__node.symLink);
      // __info.find('#name .node-data').html(__node.name);
      // __info.find('#is-group .node-data').html(__node.isGroup);
      // __info.find('#node-color .node-data').html(__node.color);
      // __info.find('#description .node-data').html(__node.description);
      // __info.find('#dialog-text .node-data').html(__node.dialogText);
      // __info.find('#node-type .node-data').html(__node.dType);
      // __info.find('#node-question .node-data').html(__node.isQuestion);
      // __info.find('#node-feedback .node-data').html(__node.isFeedback);
    },

    // to: function update the temporary connector indicating dragging affiliation
    updateTempConnector: function()
    {
      var __data = [];
      if (this.draggingNode !== null && this.selectedNode !== null) {
        // have to flip the source coordinates since we did this for the existing connectors on the original tree
        __data = [{
          source: {
            //x: this.selectedNode.y0,
            //y: this.selectedNode.x0//L/R
            x: this.selectedNode.x0,
            y: this.selectedNode.y0//T/B
          },
          target: {
            //x: this.draggingNode.y0,
            //y: this.draggingNode.x0//L/R
            x: this.draggingNode.x0,
            y: this.draggingNode.y0//T/B
          }
        }];
      }

      var __link = this.svgGroup.selectAll('.templink').data(__data);

      __link.enter().append('path')
        .attr('class', 'templink')
        .attr('d', this.d3.svg.diagonal())
        .attr('pointer-events', 'none');

      __link.attr('d', this.d3.svg.diagonal());

      __link.exit().remove();
    },

    // to: function center node when clicked/dropped so node doesn't get lost when collapsing/moving with large amount of children.
    centerNode: function(__source)
    {
      if (!this.checkWin())
        return;

      var __scale = this.zoomListener.scale();
      //var __x = -__source.y0;
      //var __y = -__source.x0;//L/R
      var __x = -__source.x0;
      var __y = -__source.y0;//T/B
      __x = __x * __scale + this.viewerWidth / 2;
      __y = __y * __scale + this.viewerHeight / 2;

      this.d3.select('g').transition()
        .duration(this.duration)
        .attr('transform', 'translate(' + __x + ',' + __y + ')scale(' + __scale + ')');

      this.zoomListener.scale(__scale);

      this.zoomListener.translate([__x, __y]);
    },

    // Toggle children function
    toggleChildren: function(d)
    {
      if (d.children) {
        d._children = d.children;
        d.children = null;
      }
      else if (d._children) {
        d.children = d._children;
        d._children = null;
      }
      return d;
    },

    // Toggle children on click.
    onClickHandler: function(d)
    {
      if (this.d3.event.defaultPrevented)
        return; // click suppressed
      //d = toggleChildren(d); REMOVED DON'T NEED TO COLLAPSE
      this.updateByID(d.nlID, true);
      return;
      // this.updateTree(d);
      // this.centerNode(d);
    },

    updateTree: function(__source)
    {

      if (!this.checkWin())
        return;
      // Compute the new height, function counts total children of root node and sets tree height accordingly.
      // This prevents the layout looking squashed when new nodes are made visible or looking sparse when nodes are removed
      // This makes the layout more consistent.
      var __levelWidth = [1];
      var __childCount = function(__level, n) {

        if (n.children && n.children.length > 0) {
          if (__levelWidth.length <= __level + 1)
            __levelWidth.push(0);

          __levelWidth[__level + 1] += n.children.length;
          n.children.forEach(function(d) {
            __childCount(__level + 1, d);
          });
        }
      };
      __childCount(0, this.root);

      //var __newHeight = this.d3.max(__levelWidth) * 25; // 25 pixels per line  //L/R
      var __newHeight = this.d3.max(__levelWidth) * (this.maxLabelLength * 10); // 25 pixels per line
      this.tree = this.tree.size([__newHeight, this.viewerWidth]);

      // Compute the new tree layout.
      this.nodes = this.tree.nodes(this.root).reverse();
      var __links = this.tree.links(this.nodes);

      // Set widths between levels based on maxLabelLength.
      this.nodes.forEach($.proxy(function(d) {
        //d.y = (d.depth * (this.maxLabelLength * 10)); //maxLabelLength * 10px//L/R
        ////console.log(d);
        d.y = (d.depth * (50)); //maxLabelLength * 10px
        // alternatively to keep a fixed scale one can set a fixed depth per level
        // Normalize for fixed-depth by commenting out below line
        // d.y = (d.depth * 500); //500px per level.
      }, this));

      // Update the this.nodes…
      var __node = this.svgGroup.selectAll('g.node')
        .data(this.nodes, $.proxy(function(d) {
          return d.id || (d.id = ++this.totalNodeIndex);
        }, this));

      // Enter any new this.nodes at the parent's previous position.
      var __nodeEnter = __node.enter().append('g')
        //.call(this.dragListener)
        .attr('class', function(d) {
          return 'node ' + d.nlID;
        })
        .attr('transform', function(d) {
          //return 'translate(' + __source.y0 + ',' + __source.x0 + ')';//L/R
          return 'translate(' + __source.x0 + ',' + __source.y0 + ')';
        })
        .on('click', $.proxy(this.onClickHandler, this));

      __nodeEnter.append('circle')
        .attr('class', 'node-circle')
        .attr('r', 10)
        .style('fill', function(d) {
          var __nColor = d.symLink ? 'lightgreen' : '#fff';
          if (d.nlID === __source.nlID)
            __nColor = 'lightsteelblue';
          return '#f00';
          //return __nColor;
        });

      __nodeEnter.append('text')
        .attr('x', function(d) {
          return d.children || d._children ? -10 : 10;
        })
        //.attr('dy', '.35em')
        .attr('class', 'node-text')
        .attr('text-anchor', function(d) {
          return d.children || d._children ? 'end' : 'start';
        })
        .text(function(d) {
          return d.name;
        })
        .style('fill-opacity', 0);

      // phantom node to give us mouseover in a radius around it
      __nodeEnter.append('circle')
        .attr('class', 'ghost-circle')
        .attr('r', 30)
        .attr('opacity', 0.2) // change this to zero to hide the target area
        .style('fill', 'red');

      // Update the text to reflect whether __node has children or not.
      __node.select('text')
        .attr('x', function(d) {
          return d.children || d._children ? -10 : 10;
        })
        .attr('text-anchor', function(d) {
          return d.children || d._children ? 'end' : 'start';
        })
        .text(function(d) {
          return d.name;
        });

      // Change the circle fill depending on whether it has children and is collapsed
      __node.select('circle.node-circle')
        .attr('r', 8)
        .style('fill', function(d) {
          ////console.log(['FILL: ', __source.nlID, d.nlID])
          var __nColor = '#fff';
          if (d.symLink === 'True')
            __nColor = 'yellow';
          else if (d.isQuestion === 'True')
            __nColor = 'lightgreen';
          else if (d.isFeedback === 'True')
            __nColor = 'pink';

          if (d.nlID === __source.nlID)
            __nColor = 'lightsteelblue';

          return __nColor;
          //return d.nlID == __source.nlID ? 'lightsteelblue' : '#fff';
          // return d._children ? 'lightsteelblue' : '#fff';
        })
        .attr('pointer-events', 'mouseover')
        .on('mouseover', $.proxy(function(__node) {
          this.overCircle(__node);
        }, this))
        .on('mouseout', $.proxy(function(__node) {
          this.outCircle(__node);
        }, this));

      // Transition this.nodes to their new position.
      var __nodeUpdate = __node.transition()
        .duration(this.duration)
        .attr('transform', function(d) {
          //return 'translate(' + d.y + ',' + d.x + ')';//L/R
          return 'translate(' + d.x + ',' + d.y + ')';
        });

      // Fade the text in
      __nodeUpdate.select('text')
        .style('fill-opacity', 1);

      // Transition exiting this.nodes to the parent's new position.
      var __nodeExit = __node.exit().transition()
        .duration(this.duration)
        .attr('transform', function(d) {
          //return 'translate(' + __source.y + ',' + __source.x + ')';// L/R
          return 'translate(' + __source.x + ',' + __source.y + ')';
        })
        .remove();

      __nodeExit.select('circle')
        .attr('r', 0);

      __nodeExit.select('text')
         .style('fill-opacity', 0);

      // Update the links…
      var __link = this.svgGroup.selectAll('path.link')
        .data(__links, function(d) {
          return d.target.id;
        });

      // Enter any new links at the parent's previous position.
      __link.enter().insert('path', 'g')
        .attr('class', 'link')
        .attr('d', $.proxy(function(d) {
          var o = {
            x: __source.x0,
            y: __source.y0
          };
          return this.diagonal({
            source: o,
            target: o
          });
        }, this));

      // Transition links to their new position.
      __link.transition()
        .duration(this.duration)
        .attr('d', this.diagonal);

      // Transition exiting this.nodes to the parent's new position.
      __link.exit().transition()
        .duration(this.duration)
        .attr('d', $.proxy(function(d) {
          var o = {
            x: __source.x,
            y: __source.y
          };
          return this.diagonal({
            source: o,
            target: o
          });
        }, this))
        .remove();

      // Stash the old positions for transition.
      this.nodes.forEach(function(d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });
    }

  });

  return new ChatmapperTree();

});

